import type { HTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

type CardProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode
}

export function Card({ children, className, ...rest }: CardProps) {
  return (
    <div
      className={cn(
        'rounded-[10px] border border-[var(--border)] bg-[var(--card)]',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  )
}

export default Card
